import { render, staticRenderFns } from "./ResetOA.vue?vue&type=template&id=98ac12de&"
import script from "./ResetOA.vue?vue&type=script&lang=js&"
export * from "./ResetOA.vue?vue&type=script&lang=js&"
import style0 from "./ResetOA.vue?vue&type=style&index=0&id=98ac12de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports